import React from "react"
import { RecoilRoot } from "recoil"
import { BaseRouter } from "router"

function App() {
  return (
    <RecoilRoot>
      <BaseRouter />
    </RecoilRoot>
  )
}

export default App
